import { Component, Input, Output, EventEmitter } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';

@Component({
  selector: 'wl-order-redirect-to-mijn',
  templateUrl: './order-redirect-to-mijn.component.html',
  styleUrls: [
    './order-redirect-to-mijn.component.essent.scss',
    './order-redirect-to-mijn.component.ed.scss',
  ],
})
export class OrderRedirectToMijnComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  @Output()
  continueAsNewCustomer: EventEmitter<void> = new EventEmitter();

  public get automationId() {
    return 'order-redirect-to-mijn';
  }

  public get fields() {
    return this.rendering?.fields;
  }
}
